import React from 'react';
import { ConfirmDialog } from 'swag-client-common/components/info/confirm-dialog/confirm-dialog';
export const SuperSpeedColorLimitationPopup = ({
  open,
  item,
  colorLimit,
  onCancel,
  onConfirm
}) => {
  const message = `Unfortunately, your logo has more colors than we can support if you switch to Super Speed.
    Please click "Edit Product" below to update your logo to one that has only ${colorLimit} color(s) so we can meet the Super Speed production timeline. 
    Or click "Continue with Original Timeline" if you want to proceed with your logo as is and stick with our Standard timelines.`;
  const handleCancel = () => onCancel(item);
  return /*#__PURE__*/React.createElement(ConfirmDialog, {
    title: "Please Update Your Logo",
    open: open,
    onCancel: handleCancel,
    onClose: onConfirm,
    onConfirm: onConfirm,
    msg: message,
    cancelText: "Edit Product",
    confirmText: "Continue with Original Timeline"
  });
};